import api from "../api";

// Progress Plans 
export const createProgressPlan = (data) => api.post("/progress-plans", data);
export const getProgressPlans = (workOrderId) =>
 api.get("/progress-plans", { params: { workOrder: workOrderId } });
export const updateProgressPlan = (id, data) =>
 api.put(`/progress-plans/${id}`, data);
export const deleteProgressPlan = (id) =>
 api.delete(`/progress-plans/${id}`);

// Planned vs Actual Comparison 
export const getProgressComparison = (params) =>
 api.get("/progress-plans/comparison", { params });

// Dashboard Summary 
export const getProgressSummary = (workOrderId, projectId) =>
 api.get("/progress-plans/summary", {
 params: {
 ...(workOrderId ? { workOrder: workOrderId } : {}),
 ...(projectId ? { project: projectId } : {}),
 },
 });
